import { render, staticRenderFns } from "./praise.vue?vue&type=template&id=e9d74a38&scoped=true&"
import script from "./praise.vue?vue&type=script&lang=js&"
export * from "./praise.vue?vue&type=script&lang=js&"
import style0 from "./praise.vue?vue&type=style&index=0&id=e9d74a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d74a38",
  null
  
)

export default component.exports